/** Mermaid diagrams for email open/click tracking. */

export const TRACKING_OVERVIEW_CHART = `
flowchart TB
  subgraph send["On send (Inngest → Postmark)"]
    SE[("scheduled_emails<br/>status → sent")]
    PM["Postmark API<br/>TrackOpens + TrackLinks on"]
    MID["postmark_message_id stored<br/>on the row"]
    SE --> PM --> MID
  end

  subgraph feedback["Feedback loop (async)"]
    RECIP["Recipient opens or clicks"]
    PMEV["Postmark fires webhook<br/>Open / Click JSON"]
    WH["postmark-webhook edge fn<br/>secret in URL path"]
    EVT[("email_engagement_events<br/>open · click + URL")]
    RECIP --> PMEV --> WH --> EVT
  end

  subgraph match["Link event → send row"]
    LOOKUP["Match MessageID →<br/>scheduled_emails.postmark_message_id"]
    WH --> LOOKUP --> EVT
    MID -.-> LOOKUP
  end

  subgraph ui["Admin UI"]
    LIVE["Live: aggregate raw events<br/>Newsletter Tracking tab · recipients"]
    EVT --> LIVE
  end

  subgraph rollup["After measurement window (~14 days)"]
    CRON["rollup-email-engagement<br/>daily 6:00 UTC"]
    RUP[("email_engagement_rollups<br/>unique opens / clickers")]
    PURGE["Delete raw events<br/>for that campaign"]
    EVT --> CRON --> RUP
    CRON --> PURGE
    RUP --> ARCH["UI reads rollups<br/>when events table empty"]
  end

  PM -.-> RECIP
`;

export const TRACKING_DATA_FLOW_CHART = `
sequenceDiagram
  participant Worker as Send worker
  participant PM as Postmark
  participant Reader as Recipient
  participant WH as postmark-webhook
  participant DB as Supabase
  participant UI as Admin app

  Worker->>PM: Send with TrackOpens + TrackLinks
  PM-->>Worker: MessageID
  Worker->>DB: scheduled_emails.sent + postmark_message_id

  Reader->>PM: Open email / click link
  PM->>WH: POST Open or Click payload
  WH->>DB: INSERT email_engagement_events
  Note over WH,DB: scheduled_email_id via MessageID lookup

  UI->>DB: Query events (live) or rollups (archived)
  UI-->>UI: Opens / clicks on newsletter & subscribers
`;
